import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import React from 'react';
import {
    TopToolbar,
    useNotify,
    useRedirect,
    useTranslate
} from 'react-admin';

import { httpClient } from 'api/httpClient';
import { MuiButtonMainProps } from 'components/_helpers/props/MuiButtonProps';

const RerunButton = ({ data, t, notify }) => {
    const handleOnClick = () => {
        httpClient('admin-actions', {
            method: "POST",
            body: JSON.stringify(data),
        }).then(({ status }) => {
            if (status === 200) {
                notify(t("osfc.messages.success"), {type: "success", autoHideDuration: 1000});
            }
        }).catch((err) => {
            notify(t("osfc.messages.unsuccess"), {type: "error", autoHideDuration: 1000});
        });
    };

    return (
        <Button variant='outlined' color="primary" onClick={handleOnClick}>
            {t('osfc.buttons.rerun')}
        </Button>
    )
};

export const AdminActionActions = (props) => {
    const {
        basePath,
        redirectPath,
        hasList,
    } = props;

    const redirect = useRedirect();
    const t = useTranslate();
    const notify = useNotify();

    return (
        <TopToolbar>
            {hasList && <Box display="flex">
                <Button startIcon={<ArrowBack/>} {...MuiButtonMainProps} size="small"
                    onClick={e => redirect(redirectPath || basePath)}>
                    {t('ra.action.back')}
                </Button>
            </Box>}
            <Box ml={1} display="flex">
                <RerunButton {...props} t={t} notify={notify} />
            </Box>
            <Box display="flex" flex="1"/>
        </TopToolbar>
    );
};
